import type { ReactElement } from 'react';
import { ArrowRight, type LucideIcon } from 'lucide-react';

export interface TextIconProps {
  /** Icon to render. Defaults to a forward arrow for CTA trails. */
  icon?: LucideIcon;
}

/**
 * Decorative Lucide icon sized to the surrounding text (`1em`).
 * `aria-hidden` — the link or button keeps its text as the accessible name.
 */
export function TextIcon({ icon: Icon = ArrowRight }: TextIconProps): ReactElement {
  return <Icon className="inline size-[1em] shrink-0 align-[-0.125em]" aria-hidden="true" />;
}
